import React, { memo } from 'react'
import { LazyLoadImage } from "react-lazy-load-image-component";
function LazyImage({src,width,height,alt,className,style}) {
  return <LazyLoadImage src={src} width={width} height={height} alt={alt} className={className} style={style}/>;
}

export default memo(LazyImage)